<template>
  <div class="warpNavlan" ref="enterRef">
       <div class="box-one">
         <div class="center">
          <div style="width: 100%;display: flex;justify-content: center;position: absolute;">
            <img src="../../../assets/enter-title.png" alt="" srcset="">
          </div>
           <div style="display: flex;align-items: center;margin-top: 30px;margin-left: 10px;">
             <span>
                加入繁淼
             </span>
             <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #333;margin-left: 20px;margin-right: 20px;"></div>
             <span style="color: #367CFF;">
                合作共赢
             </span>
           </div>
         </div>
       </div>
       <div class="box-two" @click="ruzhuBtn">
         <div>
          <span>立即入驻</span>
         </div>
       </div>
  </div>
</template>
<script>
import { gsap } from 'gsap'
export default {
 name: 'child',
 data(){
   return{
      
   }
 },
 mounted() { 
   this.initAnFun()
 },
  methods:{
    initAnFun(){
      let observer = new IntersectionObserver((enter)=>{
        if(enter[0].isIntersecting){
           gsap.from(this.$refs.enterRef,{
            opacity: 0,
            duration: 5,
           })
          observer.unobserve(this.$refs.enterRef)
        }
      },{
        root: null,
        threshold: 0.3
      })
      observer.observe(this.$refs.enterRef)
    },
    ruzhuBtn(){
        this.$router.push('/profile')
    }
  }
}
</script>
<style lang="scss" scoped>
   .warpNavlan{
     width: 100%;
     height: 388px;
     background: #FFFFFF;
     position: relative;
     box-sizing: border-box;
     padding-top: 106px;
     .box-one{
       width: 100%;
       display: flex;
       justify-content: center;
       margin-bottom: 83px;
       .center{
         width: 710px;
         height: 98px;
         position: relative;
         div{
           height: 100%;
           display: flex;
           justify-content: center;
           align-items: flex-end;

           span{
             font-size: 48px;
             font-family: Alibaba_Bold;
             color: #333333;
             line-height: 67px;
             letter-spacing: 0px;
           }
         }
       }
     }
     .box-two{
       display: flex;
       justify-content: center;
       div{
          display: flex;
          justify-content: center;
          width: 158px;
          height: 50px;
          background: #367CFF;
          border-radius: 5px;
          span{
            font-size: 20px;
            font-family: Alibaba_Bold;
            font-weight: 600;
            color: #FFFFFF;
            display: flex;
            align-items: center;
          }
       }
     }
   }
</style>

